import { render, staticRenderFns } from "./PageInfo.vue?vue&type=template&id=36cfd2a0&scoped=true&"
import script from "./PageInfo.vue?vue&type=script&lang=ts&"
export * from "./PageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PageInfo.vue?vue&type=style&index=0&id=36cfd2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cfd2a0",
  null
  
)

export default component.exports